/**
 * components/index.ts
 *
 * Automatically included in `./src/main.js`
 */
import type { App } from 'vue'

import { VueDraggableNext } from 'vue-draggable-next'

export function registerComponents(app: App) {
  app.component('v-draggable', VueDraggableNext)
}
